import React from 'react';
import PolicyLayout from './PolicyLayout';

const DataProtectionPolicy = () => (
  <PolicyLayout title="Data Protection Policy" updated="14 September 2026">
    <h2>Purpose</h2>
    <p>
      This policy explains how Project Green processes personal data
      through the intranet in line with the General Data Protection
      Regulation (EU) 2016/679 (GDPR) and the Data Protection Act
      (Cap. 586).
    </p>

    <h2>Legal basis for processing</h2>
    <ul>
      <li><strong>Performance of contract:</strong> processing needed to manage your employment, HR records, and benefits</li>
      <li><strong>Legal obligation:</strong> where required by employment or public-sector legislation</li>
      <li><strong>Legitimate interest:</strong> operating and securing internal systems, workflows, and communications</li>
    </ul>

    <h2>What we process it for</h2>
    <ul>
      <li>Maintaining the Staff Directory and internal org structure</li>
      <li>Administering onboarding, employee benefits, and HR records</li>
      <li>Handling IT Support tickets, Suggestions, and issue reports submitted through Monday.com forms</li>
      <li>Managing QMS documents, tenders, and department resources</li>
      <li>Internal communications, news, and events</li>
    </ul>

    <h2>Categories of data</h2>
    <p>
      Contact details, employee ID and role information, department and
      HR data, and content you submit through intranet forms.
    </p>
    <p>
      We do not routinely process special categories of data (e.g. health,
      racial or ethnic origin, religious beliefs). Where this is
      unavoidable — for example, accessibility accommodations — it is
      handled under the safeguards required by Article 9 GDPR.
    </p>

    <h2>Who we share data with</h2>
    <ul>
      <li>Authorised internal departments and management, on a need-to-know basis</li>
      <li>Third-party processors supporting the intranet (Microsoft Azure, Monday.com, Talexio), under written data processing agreements</li>
      <li>Law enforcement or regulators, where legally required</li>
    </ul>

    <h2>Your rights</h2>
    <ul>
      <li>Access, correct, or request erasure of your data</li>
      <li>Restrict or object to certain processing</li>
      <li>Request portability of data you provided</li>
      <li>Withdraw consent where processing relies on it</li>
    </ul>
    <p>
      Requests should be made in writing to the Data Protection Officer.
      We aim to respond within one month.
    </p>

    <h2>Contact details</h2>
    <div className="policy-contact-box">
      <p><strong>Data Protection Officer</strong></p>
      <p>Project Green, Avenue 77, Triq in-Negozju, Zone 3, CBD, Birkirkara CBD3010, Malta</p>
      <p>Email: dpo.pg@projectgreen.mt</p>
    </div>
    <p>
      You have the right to lodge a complaint with the Information and
      Data Protection Commissioner (idpc.org.mt).
    </p>
  </PolicyLayout>
);

export default DataProtectionPolicy;